import { USER_API } from '@/constants/urls'
import axios from '@/helpers/axios'
import { useAppSelector } from '@/hooks/useReduxHooks'
import { IMessageAboutComplete, ISurvey } from '@/models'
import { useQuery } from '@tanstack/react-query'

export const useSurveyProgress = (quizId: string | undefined, enabled: boolean) => {
  const accessToken = useAppSelector((state) => state.auth.accessToken)
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ['progress'],
    queryFn: async () => {
      const response = await axios.post<ISurvey>(
        `${USER_API}/survey/progress`,
        { quiz_id: quizId },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      return response.data
    },
    select: (data) => data,
    meta: { errorMessage: 'При запуске опроса произошла ошибка' },
    enabled: enabled && !!accessToken,
    retry: false
  })
  return {
    surveyProgress: data,
    surveyProgressRefetch: refetch,
    surveyProgressIsLoading: isLoading,
    surveyProgressError: error
  }
}

export const useGetMessageAboutComplete = (surveyUuid: string | undefined) => {
  const accessToken = useAppSelector((state) => state.auth.accessToken)
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ['success-message-about-complete'],
    queryFn: async () => {
      const response = await axios.get<IMessageAboutComplete>(
        `${USER_API}/survey/progress/${surveyUuid}/success-message-about-complete`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      return response.data
    },
    select: (data) => data,
    meta: { errorMessage: 'При получении сообщения о завершении опроса произошла ошибка' },
    enabled: !!surveyUuid,
    retry: false
  })
  return {
    messageAboutComplete: data,
    messageAboutCompleteRefetch: refetch,
    messageAboutCompleteIsLoading: isLoading,
    messageAboutCompleteError: error
  }
}
